'use client';

import { RootState } from '@/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';


interface BodyStyleProviderProps {
  children: React.ReactNode;
}

export default function BodyStyleProvider({
  children,
}: BodyStyleProviderProps) {
  const { general } = useSelector((state: RootState) => state.settings);

  const cssVariables = {
    '--body-bg': { key: 'website_body_bg', defaultValue: '#f5f7fa' },
    '--body-text-color': {
      key: 'website_body_text_color',
      defaultValue: '#121416',
    },
    '--main-color': { key: 'website_main_color', defaultValue: '#3a3d41' },
    '--second-color': { key: 'website_second_color', defaultValue: '#0071B7' },
    '--home-category-bg': {
      key: 'website_home_category_bg',
      defaultValue: '#adb8f4',
    },
    '--header-bg': { key: 'website_header_bg', defaultValue: '#d0d4dd' },
    '--header-text-color': {
      key: 'website_header_text_color',
      defaultValue: '#121416',
    },
    '--footer-bg': { key: 'website_footer_bg', defaultValue: '#d1d3dd' },
    '--footer-text-color': {
      key: 'website_footer_text_color',
      defaultValue: '#121416',
    },
    '--sub-footer-bg': {
      key: 'website_sub_footer_bg',
      defaultValue: '#3a3d41',
    },
    '--sub-footer-text-color': {
      key: 'website_sub_footer_text_color',
      defaultValue: '#ffffff',
    },
    '--product-bg': { key: 'website_product_bg', defaultValue: '#ffffff' },
    '--badge-bg-1': { key: 'website_badge_bg_1', defaultValue: '#636363' },
    '--badge-bg-2': { key: 'website_badge_bg_2', defaultValue: '#0071B7' },
    '--instock-text-color': {
      key: 'website_instock_text_color',
      defaultValue: '#07914f',
    },
    '--outstock-text-color': {
      key: 'website_outstock_text_color',
      defaultValue: '#C11B1B',
    },
  };

  useEffect(() => {
    Object.entries(cssVariables).forEach(([cssVar, { key, defaultValue }]) => {
      const value = general?.[key] || defaultValue;
      document.body.style.setProperty(cssVar, value);
    });

    return () => {
      Object.keys(cssVariables).forEach((cssVar) => {
        document.body.style.removeProperty(cssVar);
      });
    };
  }, [general]);

  return (
   children
  );
}
